import React from 'react';

function LogicChallengeExplorer() {
  return <div>LogicChallengeExplorer</div>;
}

export default LogicChallengeExplorer;
